import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormInput from '@src/utility/FormInput';
import FluidImage from '@src/utility/FluidImage';
import ArrowIcon from '../../../static/images/icons/icon-arrow-right-m.svg';
import FirebaseContext from '@context/FirebaseContext';
import { useForm } from 'react-hook-form';
import { EMAIL_ERROR_MESSAGE, EMAIL_FIELD_PATTERN, REQUIRED_FIELD } from '../../../common';
import Button from '@components/Button';
import Link from '@src/utility/Link';
import { navigate, useLocation } from '@reach/router';
import AuthUserContext from '@src/context/AuthUserContext';
import { graphql, useStaticQuery } from 'gatsby';
import * as styles from './styles';
import cn from 'classnames';
import Spinner from '../../../static/images/loader-circle.gif';

// data =  subscribe || createProfile
const GateWall = () => {
    const { authUser } = useContext(AuthUserContext);
    const location = useLocation();
    const firebase = useContext(FirebaseContext);
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
        reset
    } = useForm();

    const { allSanityGateWall } = useStaticQuery(
        graphql`
          query {
              allSanityGateWall {
                edges {
                  node {
                    id
                    subscribe {
                      headerCopy
                      urls
                      altText
                      image {
                            asset {
                            _id
                            extension
                            url
                            }
                        }
                    }
                    createProfile {
                      headerCopy
                      urls
                      altText
                      image {
                            asset {
                            _id
                            extension
                            url
                            }
                        }
                    }
                  }
                }
              }
            }
        `,
    );

    const [isSubmitted, setSubmitted] = useState(false);
    const [isFromKlaviyo, setIsFromKlaviyo] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showGateWall, setShowGateWall] = useState(false);
    const [loadGateWall, setLoadGateWall] = useState(false);
    const [gateWallType, setGateWallType] = useState(null); // subscribe || createProfile


    useEffect(() => {
        if (allSanityGateWall && loadGateWall && gateWallType) {
            if (!localStorage.getItem("gatewallSubmit")) {
                if (!authUser) {
                    setTimeout(() => {
                        setShowGateWall(true)
                    }, 1000)
                }
            } else {
                if (!authUser) {
                    if (gateWallType !== "subscribe") {
                        setTimeout(() => {
                            setShowGateWall(true)
                        }, 1000)
                    }
                }
            }
        }

    }, [allSanityGateWall, loadGateWall, gateWallType])

    useEffect(() => {
        if (showGateWall) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showGateWall]);

    useEffect(() => {
        setTimeout(() => {
            initGatewall();
            setSubmitted(false)
        }, 1000)
    }, [location.pathname, authUser])

    useEffect(() => {
        const isKlaviyoParams = new URLSearchParams(location.search);
        if (isKlaviyoParams.get('_kx')) {
            setIsFromKlaviyo(true)
        }
    }, [location.search])

    async function initGatewall() {

        if (authUser?.email || isFromKlaviyo) {
            closeGateWall();
            return;
        }

        const pathname = location.pathname.endsWith("/") ? location.pathname.slice(0, -1) : location.pathname
        const firstPath = "/" + pathname.split("/")[1]
        if (allSanityGateWall?.edges[0]?.node?.subscribe?.urls.includes(pathname) || allSanityGateWall?.edges[0]?.node?.subscribe?.urls.includes(firstPath)) {
            setGateWallType("subscribe")
            setLoadGateWall(true)
        } else if (allSanityGateWall?.edges[0]?.node?.createProfile?.urls.includes(pathname) || allSanityGateWall?.edges[0]?.node?.createProfile?.urls.includes(firstPath)) {
            setGateWallType("createProfile")
            setLoadGateWall(true);
        } else {
            closeGateWall();
        }
    }

    const closeGateWall = () => {
        setShowGateWall(false)
        setTimeout(() => {
            setLoadGateWall(false)
        }, 2000);
    }

    const submit = (data2) => {
        setIsSubmitting(true);
        firebase
            .subscribeKlaviyoFromGatewall(data2)
            .then((response) => {
                handleDataSubmit();
            })
            .catch((err) => {
                console.error(err)
                handleDataSubmit();
            });
        if (gateWallType === "createProfile") {
            const pathname = location.pathname.endsWith("/") ? location.pathname.slice(0, -1) : location.pathname
            localStorage.setItem("gatewallReturnUrl", pathname);

            const query = new URLSearchParams({
                email: data2.email,
                firstName: data2.firstName,
                lastName: data2.lastName,
                companyName: data2.companyName,
            }).toString();

            navigate(`/account/create?${query}`, { replace: true });
            // setShowGateWall(false)
            // return
        }
    };

    const handleDataSubmit = () => {
        setIsSubmitting(false);
        localStorage.setItem("gatewallSubmit", "true")
        close()
        reset()
        setSubmitted(true)
        setTimeout(() => {
            setShowGateWall(false)
            setTimeout(() => {
                setLoadGateWall(false)
            }, 2000)
        }, 2000);
    }

    const getGateWallImgSrcObj = () => {
        if (gateWallType === "createProfile") {
            return allSanityGateWall?.edges[0]?.node?.createProfile?.image?.asset?.url
        } else if (gateWallType === "subscribe") {
            return allSanityGateWall?.edges[0]?.node?.subscribe?.image?.asset?.url   
        }
    }

    if (!loadGateWall) return <></>;
    
    return (
        <div className={`${styles.gateWall} ${showGateWall ? styles.visible : styles.hidden}`}>
            <div className="w-[50%] hidden lg:block">
                <img src={getGateWallImgSrcObj()} className="w-full h-full object-cover"/>
            </div>
            <div className={"py-5 px-5 lg:px-12 w-full lg:w-[50%]"} >
                {!isSubmitted && <>
                    <p className='type-sans-430 w-full lg:w-[70%] text-center m-auto mb-2'>
                        { allSanityGateWall?.edges[0]?.node?.[gateWallType]?.headerCopy }
                    </p>
                    <form
                        onSubmit={ handleSubmit(submit) }
                        className='relative'>
                        
                        <div className='grid grid-cols-2 gap-2'>
                            <FormInput
                                type="firstName"
                                { ...register('firstName', {
                                    required: true,
                                })}
                                placeholder="First Name"
                                name="firstName"
                                errorMessage={
                                    errors.firstName &&
                                    (errors.firstName.type === 'required'
                                        ? REQUIRED_FIELD
                                        : '')
                                }
                                disabled={ isSubmitted }
                            />

                            <FormInput
                                type="lastName"
                                { ...register('lastName', {
                                    required: true,
                                })}
                                placeholder="Last Name"
                                name="lastName"
                                errorMessage={
                                    errors.lastName &&
                                    (errors.lastName.type === 'required'
                                        ? REQUIRED_FIELD
                                        : '')
                                }
                                disabled={ isSubmitted }
                            />
                        </div>

                        <FormInput
                            type="companyName"
                            { ...register('companyName', {
                                required: true,
                            }) }
                            placeholder="Company Name"
                            name="companyName"
                            errorMessage={
                                errors.companyName &&
                                (errors.companyName.type === 'required'
                                    ? REQUIRED_FIELD
                                    : '')
                            }
                            disabled={ isSubmitted }
                        />

                        <FormInput
                            type="email"
                            { ...register('email', {
                                required: true,
                                pattern: EMAIL_FIELD_PATTERN,
                            }) }
                            placeholder="Enter your email"
                            // label={ gateWallType === "createProfile" ? "CREATE PROFILE" : "SIGN UP WITH EMAIL" }
                            name="email"
                            errorMessage={
                                errors.email &&
                                (errors.email.type === 'required'
                                    ? REQUIRED_FIELD
                                    : EMAIL_ERROR_MESSAGE)
                            }
                            disabled={ isSubmitted }
                        />

                        <Button
                            aria-label="Submit"
                            type="submit"
                            className={ cn(
                                'btn-default btn-black btn-lg mt-4 btn-interaction',
                                {
                                'btn-black-disabled': !isValid,
                                },
                                { 'is-loading': isSubmitting },
                            ) }
                            disabled={ isSubmitting }
                            >
                            <>
                                <span>{gateWallType === "createProfile" ? "CREATE PROFILE" : "SIGN UP WITH EMAIL"}</span>
                                <span>
                                <img
                                    src={ Spinner }
                                    alt="Loading"
                                    width="16px"
                                    height="16px"
                                    className="ml-6 absolute left-0 top-0"
                                />
                                LOADING
                                </span>
                            </>
                        </Button>

                        {/* {!isSubmitting && <Button
                            type="submit"
                            className='absolute right-0 top-[45px] cursor-pointer '
                        >
                            <img
                                src={ ArrowIcon }
                                alt="Right arrow icon"
                            />
                        </Button>}
                        {isSubmitting && <div className={styles.spinner}></div>} */}
                    </form>
                    {
                        gateWallType === "createProfile" && (
                            <p className='type-sans-230'>
                                Already have an account?&nbsp; 
                                <Link to="/account/login" styled={ false } className="inline-link" aria-label="Login" onClick={() => localStorage.setItem("gatewallReturnUrl", location.pathname)}>
                                    Login
                                </Link>
                            </p>
                        )
                    }
                </>}

                {
                    isSubmitted && (
                        <p className='type-sans-530 text-center m-auto h-full flex items-center justify-center'>
                            Thank you for subscribing!
                        </p>
                    )
                }
                
            </div>
        </div>
    );
};

// GateWall.propTypes = {
//     gateWallData: PropTypes.shape({
//         gateWallType: PropTypes.string.isRequired,
//         headerCopy: PropTypes.string.isRequired,
//         image: PropTypes.object,
//         urls: PropTypes.arrayOf(PropTypes.string),
//     }).isRequired,
// };

export default GateWall;